<template>
  <v-container fluid v-if="sprint != null">
    <v-layout row wrap>
      <v-flex pa-2>
        <v-card>
          <v-toolbar>
            <v-toolbar-title>{{ sprint.name }}</v-toolbar-title>
          </v-toolbar>
          <v-list>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Start</v-list-tile-title>
                <v-list-tile-sub-title>{{ sprint.start | formatDate }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>End</v-list-tile-title>
                <v-list-tile-sub-title>{{ sprint.end | formatDate }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="remove(sprint)">
              Remove
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-btn
      bottom
      fab
      fixed
      right
      @click="goToEdit"
    >
      <v-icon>create</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: 'SprintShowView',
  computed: {
    sprint() {
      return this.$store.getters.getSprint(this.$route.params.id);
    },
  },
  methods: {
    goToEdit() {
      this.$router.push({
        name: 'Edit Sprint',
        params: { id: this.$route.params.id },
      });
    },
    remove(sprint) {
      this.$store.commit('deleteSprint', sprint);
      this.$router.push({ name: 'Sprints' });
    },
  },
};
</script>
